import React from "react";
import { Container, Box, Typography } from "@mui/material";
import { MapPin, ShoppingCart, Codesandbox, Phone, Clock } from "react-feather";

const Footer = () => {
  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        pt: 2,
        pb: 3,
        backgroundColor: "#e1e2e2",
        borderColor: "#cbcbcb75",
      }}
      id="contact"
    >
      <Container maxWidth="lg" sx={{ mt: 1 }}>
        <Box className="flex flex-col md:flex-row justify-between items-start md:items-start-3 gap-6">
          {/* Services Section */}
          <Box>
            <Typography className="text-[#005693] font-bold text-[14px] uppercase">
              Манай үйлчилгээ
            </Typography>
            <Box className="flex items-center pb-4 mt-4">
              <Codesandbox size={20} color="#044ba1" className="mr-2" />
              <Typography className="text-[14px] font-bold text-[#545454]">
                БНХАУ-ын бүх хот мужуудаас шуурхай тээвэр
              </Typography>
            </Box>
            <Box className="flex items-center pb-4">
              <ShoppingCart size={20} color="#044ba1" className="mr-2" />
              <Typography className="text-[14px] font-bold text-[#545454]">
                Хятадын онлайн шопуудаас захиалга хийх сургалт
              </Typography>
            </Box>
            <Box className="flex items-center pb-2">
              <ShoppingCart size={20} color="#044ba1" className="mr-2" />
              <Typography className="text-[14px] font-bold text-[#545454]">
                Alipay, Wechat юаны шилжүүлэг
              </Typography>
            </Box>
          </Box>

          {/* Working Hours Section */}
          <Box>
            <Typography className="text-[#005693] font-bold text-[14px] uppercase">
              Ажиллах цагийн хуваарь
            </Typography>
            <Box className="flex items-center pb-2">
              <Clock size={20} color="#044ba1" className="mr-2" />
              <Typography className="text-[14px] font-bold text-[#545454]">
                Мяг-Ням 10:00-20:00
              </Typography>
            </Box>
          </Box>

          {/* Contact Section */}
          <Box>
            <Typography className="text-[#005693] font-bold text-[14px] uppercase">
              Холбоо барих
            </Typography>
            <Box className="flex items-center pb-2">
              <Phone size={20} color="#044ba1" className="mr-2" />
              <Typography className="text-[14px] font-bold text-[#545454]">
                96109444
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Copyright Section */}
        <Typography
          variant="body2"
          className="text-center text-[11px] font-medium text-black uppercase mt-2"
        >
          ©2025 Зохиогчийн эрх хуулиар хамгаалагдсан.
        </Typography>
      </Container>
    </Container>
  );
};

export default Footer;
